import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import BackToTop from '@/components/feature/BackToTop';
import CategoryView from '@/pages/category/components/CategoryView';
import { rimanComics } from '@/mocks/comics';

export default function Riman() {
  return (
    <>
      <Navbar />
      <main>
        <CategoryView
          type="riman"
          label="日漫"
          tagline="日漫分类大全，热血、治愈、科幻、日常等题材齐全。从人气连载到经典作品，按类型快速找到你想看的日漫。"
          comics={rimanComics}
        />
      </main>
      <Footer />
      <BackToTop />
    </>
  );
}